/* import __COLOCATED_TEMPLATE__ from './seller-posting-meta.hbs'; */
import { computed } from '@ember/object';
import { equal, readOnly } from '@ember/object/computed';
import { htmlSafe } from '@ember/template';
import Component from '@ember/component';
import moment from 'moment';

/** @module */
const SellerPostingMetaComponent = Component.extend({
  /** @inheritDoc */
  tagName: 'ul',

  /** @inheritDoc */
  classNames: ['seller-posting-meta'],

  /** @inheritDoc */
  classNameBindings: [
    'isGrayVariant:seller-posting-meta--gray',
  ],

  /** @type {DS.Model} */
  data: null,

  /** @type {boolean} */
  clampLocation: false,

   /** @type {undefined|gray} */
  color: undefined,

  /** @type {Ember.ComputedProperty} */
  isGrayVariant: equal('color', 'gray'),

  /** @type {Ember.ComputedProperty} */
  deadlineHtml: computed('data.createdAt', 'data.deadline', function() {
    const createdAt = this.data.createdAt;
    const expires = this.data.deadline;

    const postedAt = `Posted ${moment(createdAt).fromNow()}`;

    if (!expires) {
      return postedAt;
    }

    const now = moment();
    const threshold = now.clone().add(3, 'days');
    const deadline = moment(expires);

    let expiresIn = deadline.isBefore(now) ?
      `Expired ${deadline.fromNow()}` :
      `Expires in ${deadline.fromNow()}`;

    if (deadline.isBetween(now, threshold)) {
      expiresIn = `<strong>${expiresIn}</strong>`;
    }

    return htmlSafe(`${postedAt} • ${expiresIn}`);
  }),

  /** @type {Ember.ComputedProperty} */
  location: readOnly('data.locationText'),

  /** @type {Ember.ComputedProperty} */
  rate: readOnly('data.costText'),
});

export default SellerPostingMetaComponent;
